import React, { useEffect, useState } from "react";

import { Descriptions, Progress } from "antd";

import { isEmpty } from "lodash";

import moment from "moment";
import "moment-timezone";

import { fileSize } from "../../libs/utils";

function RobotInfo(props) {
  const NOVARC_SW = ["NovData", "WeldVision", "NovEye", "NovSync"];

  const {
    robot: {
      hubspot_information = {},
      swr_information = [],

      // swr_information = {
      //   name: null, // customer
      //   city: null, // location
      //   power_source: null, //
      //   timezone: null, //
      //   operator: null, // operator contact
      // },
    },

    robot,
    isCustomer,
    tier,
  } = props;

  const [localTime, setLocalTime] = useState(moment());

  useEffect(() => {
    const interval = setInterval(() => setLocalTime(moment()), 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const ring = robot.space
    ? (parseInt(robot.space.used, 10) / parseInt(robot.space.total, 10)) * 100
    : null;

  const bandwidthRing =
    tier && tier.used ? (tier.used / tier.capacity) * 100 : null;

  const novarcSoftware = robot.versions
    .map((item, index) => {
      return NOVARC_SW.includes(item.name) ? item : null;
    })
    .filter((item) => item);

  const latestSoftware = Array.from(
    novarcSoftware
      .reduce((m, obj) => {
        const curr = m.get(obj.name);
        return m.set(
          obj.name,
          curr ? (curr.install_date < obj.install_date ? obj : curr) : obj
        );
      }, new Map())
      .values()
  );

  const swr_summary = {
    customer:
      (swr_information.length > 0 &&
        swr_information.find((item) => item.key === "client_name").value) ||
      hubspot_information.name ||
      robot.customer,
    location:
      (!isEmpty(hubspot_information) &&
      hubspot_information.city + hubspot_information.country
        ? hubspot_information.city + ", " + hubspot_information.country
        : null) || robot.location,
    last_online: (robot.summary && robot.summary.date) || "N/A",
    power_source:
      (swr_information.length > 0 &&
        swr_information.find((item) => item.key === "power_source").value) ||
      hubspot_information.power_source ||
      null,
    operator:
      (swr_information.length > 0 &&
        swr_information.find((item) => item.key === "name_mc").value) ||
      hubspot_information.name_mc ||
      null,
    local_time: moment
      .tz(
        localTime,
        hubspot_information.timezone ||
          Intl.DateTimeFormat().resolvedOptions().timeZone
      )
      .format("llll"),
  };

  return (
    <>
      <Descriptions
        title={"SWR Summary"}
        bordered
        size={"small"}
        column={{ xxl: 3, xl: 2, lg: 1, md: 1, sm: 1, xs: 1 }}
      >
        <Descriptions.Item label={"Customer"}>
          {swr_summary.customer}
        </Descriptions.Item>
        {!isCustomer && (
          <Descriptions.Item label={"Location"}>
            {swr_summary.location}
          </Descriptions.Item>
        )}
        {robot.summary && (
          <Descriptions.Item label={"Last Online"}>
            {swr_summary.last_online}
          </Descriptions.Item>
        )}

        {!isCustomer && (
          <Descriptions.Item label={"Power Source"}>
            {swr_summary.power_source}
          </Descriptions.Item>
        )}
        {!isCustomer && (
          <Descriptions.Item label={"Operator"}>
            {swr_summary.operator}
          </Descriptions.Item>
        )}
        <Descriptions.Item label={"Local Time"}>
          {swr_summary.local_time}
        </Descriptions.Item>
      </Descriptions>

      <br />

      <Descriptions
        column={{ xxl: 3, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
        title={"SWR Software"}
        bordered
        size={"small"}
      >
        {latestSoftware &&
          latestSoftware.map((item, index) => {
            return (
              <Descriptions.Item key={index} label={item.name}>
                {item.version}
              </Descriptions.Item>
            );
          })}

        {robot.space && (
          <Descriptions.Item label={"Disk Usage"}>
            <Progress
              type="circle"
              percent={ring}
              format={() => `${Math.round(ring)} %`}
              strokeColor={
                ring > 85 ? "#f5222d" : ring > 70 ? "#fa8c16" : "#1890ff"
              }
            ></Progress>
            <br />
            {`${robot.space.free} Left / ${robot.space.total}`}
          </Descriptions.Item>
        )}

        {tier && (
          <Descriptions.Item
            label={
              <span>
                Download Usage <br />
                <i style={{ fontSize: "0.8em" }}>
                  {moment(localTime)
                    .set("date", tier.recurring_date)
                    .format("MMM Do")}{" "}
                  {" ~ "}
                  {moment(localTime)
                    .add(1, "months")
                    .set("date", tier.recurring_date)
                    .subtract(1, "days")
                    .format("MMM Do")}
                </i>
              </span>
            }
          >
            <Progress
              className="UsageProgress"
              type="circle"
              percent={bandwidthRing}
              format={() =>
                `${bandwidthRing > 100 ? 100 : Math.round(bandwidthRing)} %`
              }
              strokeColor={
                bandwidthRing > 85
                  ? "#f5222d"
                  : bandwidthRing > 70
                  ? "#fa8c16"
                  : "#1890ff"
              }
            ></Progress>
            <br />
            {`${fileSize(
              Number(tier.capacity) < Number(tier.used)
                ? 0
                : Number(tier.capacity) - Number(tier.used)
            )} Left / ${fileSize(tier.capacity)}`}
          </Descriptions.Item>
        )}
      </Descriptions>
    </>
  );
}

export default RobotInfo;
